export { default } from "./ScmBanner";
